import React from 'react';
import { DropDown } from './common';
import {validatable} from 'components/utils';
import {DuLieuHeThong} from 'api';

class DropDownChonKetLuanNoiDungKhieuNai extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      loaiDon: this.props.loaiDon
    }
  }
  componentDidMount() {
    this.getListData(this.state.loaiDon);
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.loaiDon != nextProps.loaiDon) {
      this.getListData(nextProps.loaiDon);
    }
  }

  getListData(loaiDon) {
    let params = {
      loaiDon: loaiDon
    }
    DuLieuHeThong.actions.getKetLuanNoiDungKhieuNai.request(params).then(res => {
      if(this.refs.DropDownChonKetLuanNoiDungKhieuNai && res.data) {
        this.setState({
          data: res.data
        })
      };
    })
  }

  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <DropDown ref="DropDownChonKetLuanNoiDungKhieuNai" label={this.props.label} bindValidator={this} channel="formTaoDon" selectedValue={this.props.selectedValue}  require={this.props.require} isValid={this.props.isValid} options={this.state.data} keyName='giaTri' valueName='ten' onChange={this.onChange.bind(this)} placeholder={this.props.placeholder} className={'col-input '+this.props.className} name={this.props.name}/>
    )
  }
}

DropDownChonKetLuanNoiDungKhieuNai.defaultProps = {
  className: 'input-group',
  loaiDon: '',
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  require: false,
  isValid: false,
  label: "Kết luận nội dung khiếu nại",
  name:'dropdownChonKetLuanNoiDungGiaoTTXM'
}

export default validatable(DropDownChonKetLuanNoiDungKhieuNai);



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-chonketluannoidungkhieunai.jsx